import axios from 'axios';
import { getStoredUser, storeUser } from '../utils/authStorage';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

axiosInstance.interceptors.request.use(
  config => {
    const user = getStoredUser();
    if (user && user.authToken) {
      config.headers.Authorization = `Bearer ${user.authToken}`;
    }
    config.withCredentials = true;
    return config;
  },
  error => {
    return error;
  },
);

let refreshRequest = null;

const isRecoverableAuthenticationError = error => {
  const status = error && error.response && error.response.status;
  const message = error && error.response && error.response.data && error.response.data.message;

  return [401, 403].includes(status) && ['jwt expired', 'No auth token'].includes(message);
};

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error && error.config;
    if (
      !originalRequest ||
      originalRequest.skipAuthRefresh ||
      originalRequest._authRetry ||
      !isRecoverableAuthenticationError(error)
    ) {
      return Promise.reject(error);
    }

    originalRequest._authRetry = true;

    try {
      if (!refreshRequest) {
        refreshRequest = axiosInstance
          .post('/users/refreshToken', {}, { skipAuthRefresh: true })
          .then(response => {
            const authToken = response && response.data && response.data.authToken;
            if (authToken) {
              const user = getStoredUser();
              if (user) storeUser({ ...user, authToken });
            }
            return response;
          })
          .finally(() => {
            refreshRequest = null;
          });
      }

      await refreshRequest;
      return axiosInstance(originalRequest);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  },
);
